<template>
	<div v-if="first" style="width: 100%">
		
		<div v-if="minimal && !workflow">
			<b-button @click="send_treatment" variant="success">Sélectionner le traitemment</b-button>
			<br /><br />
		</div>
		
		<h2 v-if="!minimal" class="my-4"><u>Projet</u>: {{ project }}</h2>
		<p v-else><u>Projet</u>: {{ project }}</p>

		<!-- * Ancien button de révélation de collapseInfos -->
		<!-- <div style="cursor:pointer;" class="d-flex w-50 align-items-center bg-white mb-2" @click="details_open = !details_open">

			<div style="font-size: large;" class="align-text-bottom w-100 m-1 rounded-lg">
				Détails
			</div>
			<i style="transition-duration: 0.5s;" :style="{transform: details_open ? 'rotate(-180deg)' : ''}" class="fas fa-chevron-down"></i>
		</div> -->

		<!-- * Ancien conteneur de détails -->
		<!-- <b-collapse id="collapseInfos" v-model="details_open">
			<div v-if="extra">
				<p>Utilisateur : {{ user ? user.prenom + " " + user.nom + " - " + user.identifiant : "non défini" }}</p>
				<p>Date de début : {{ date_start }}</p>
				<p v-if="status">Date de fin : {{ date_end }}</p>
				<p>Statut : {{ status ? status.toLowerCase() : "en cours" }}</p>
			</div>
    </b-collapse> -->

		<div v-if="!status" class="center_spinner">
			<fade-loader></fade-loader>
			<br /><br />
		</div>

		<div v-if="!details.stop && status != 'ko' && status != 'ok'">
			<b-button @click="stop_treatment" variant="danger">Arrêter le traitement</b-button>
			<br /><br />
		</div>
		<div v-if="details.stop && status != 'ko' && status != 'ok'">
			Le traitement va s'arrêter.
			<br /><br />
		</div>

		<!-- * onglets -->
		<b-tabs content-class="mt-3">
			<b-tab title="Résultat">
				<div v-if="details.log_stop">Le traitement a été stoppé : {{details.log_stop}}</div>
				<div v-show="status || details_view">
					<b-alert show variant="danger" v-if="status === 'ko'">
						{{details.error ? details.error : "Erreur"}}
					</b-alert>
					<div v-if="details_view || status != 'ko'">
						<div v-if="details_view">
							<b-button @click="getTreatment(true)">Tout les fichiers</b-button>
							<br /><br />
						</div>
						<b-table striped hover :items="files" :fields="fields">
							<template v-slot:cell(download)="data">
								<b-button @click="getFile(data)"
									><i class="fas fa-file-download"></i
								></b-button>
								&nbsp;
								<b-button
									v-if="
										data.item.name.endsWith('.csv') ||
										data.item.name.endsWith('.xml') ||
										data.item.name.endsWith('.pdf') ||
										data.item.name.endsWith('.docx')
									"
									@click="
										viewFile(
											data,
											data.item.name,
											data.item.details,
											data.item
										)
									"
									><i class="fas fa-eye"></i
								></b-button>
							</template>
						</b-table>
						<!-- * s'il n'y a qu'un fichier de sortie, ne pas re-afficher son nom -->
						<viewFile
							@update="update_file"
							:project="project_data"
							:treatment="result.treatment"
							ref="view_file"
							:showFileName="
								files.length > 1 ? true : false
							"></viewFile>
						<span
							v-for="action in list_actions_result"
							:key="action.name">
							&nbsp;<b-button
								variant="success"
								v-on:click="
									start_treatment(
										action.tags,
										action.project,
										action.type,
										false
									)
								"
								>{{ action.name }}</b-button
							>
						</span>
						<treatment v-show="launch" ref="myTreatment"></treatment>
					</div>
				</div>
			</b-tab>
			<b-tab title="Informations">
				<div v-if="details.log_stop">Le traitement a été stoppé : {{details.log_stop}}</div>
				<div v-if="extra">
					<!-- * user info -->
					<div class="my-4">
						<div class="font-thin text-2xl mb-2">UTILISATEUR</div>
						<div class="font-medium text-xl">
							{{
								user
									? user.prenom +
									  " " +
									  user.nom +
									  " - " +
									  user.identifiant
									: "non défini"
							}}
						</div>
					</div>
					<!-- * Date début -->
					<div class="my-4">
						<div class="font-thin text-2xl mb-2">DATE DEBUT</div>
						<div class="font-medium text-xl">
							{{ date_start }}
						</div>
					</div>
					<!-- * Date fin -->
					<div class="my-4" v-if="status">
						<div class="font-thin text-2xl mb-2">DATE FIN</div>
						<div class="font-medium text-xl">
							{{ date_end }}
						</div>
					</div>
					<!-- * Statut -->
					<div class="my-4">
						<div class="font-thin text-2xl mb-2">STATUT</div>
						<div class="font-medium text-xl">
							{{ status ? status.toLowerCase() : "en cours" }}
						</div>
					</div>
				</div>
				<!-- * barre de progression indiquant [début] -- [durée] -- [fin] -->
				<div>
					<b-progress v-if="status === 'ok'" :max="3" height="2rem">
						<b-progress-bar :variant="'info'" value="1">
							<span style="font-size: medium">
								Commencé: <u>{{ date_start }}</u></span
							>
						</b-progress-bar>
						<b-progress-bar :variant="'info'" value="1">
							<span style="font-size: medium">
								<!-- get time in seconds between two dates -->
								Durée:
								<u>{{ get_duration(date_start, date_end) }}</u>
							</span>
						</b-progress-bar>
						<b-progress-bar :variant="'info'" value="1">
							<span style="font-size: medium"
								>Terminé: <u>{{ date_end }}</u></span
							>
						</b-progress-bar>
					</b-progress>
					<!-- * en cas d'erreur: -->
					<b-progress v-if="status !== 'ok'" :max="1" height="2rem">
						<b-progress-bar
							:variant="status === 'ko' ? 'danger' : 'warning'"
							:value="1"
							:animated="status !== 'ko'">
							<span style="font-size: medium">
								{{ status === "ko" ? (details.error ? details.error : "Erreur") : "En cours" }}
							</span>
						</b-progress-bar>
					</b-progress>
				</div>
			</b-tab>
			<b-tab v-if="details_view" title="Détails">
				Details : 
				<pre>{{details_json}}</pre>
			</b-tab>
			<b-tab v-if="details_view" title="Logs">
				Logs : 
				<b-table v-if="logs" striped hover :items="logs" :fields="fields_logs">
				</b-table>
			</b-tab>
			<b-tab v-if="details_view" title="Compteurs">
				Compteurs : 
				<b-table v-if="meters" striped hover :items="meters" :fields="fields_meters">
				</b-table>
			</b-tab>
		</b-tabs>

		<div v-if="project_data.details && project_data.details.details && project_data.details.details.next_treatments">		
			<div v-if="!workflow">
				<b-button v-if="!is_create" @click="is_create = true"><i class="fas fa-plus"></i> traitement</b-button>
				<create v-if="status && is_create" :url_files="files" :initial_data="false" :next_treatments="(project_data.details && project_data.details.details && project_data.details.details.next_treatments) ? project_data.details.details.next_treatments : []"/>
			</div>
			<div v-else-if="selection_projects_options.length > 1">
				<b-select v-model="selection_project" :options="selection_projects_options" />
				<b-button @click="add_project_workflow">Ajouter</b-button>
			</div>
		</div>
	</div>
</template>

<script>
	import { JSONEditor } from "@json-editor/json-editor";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	import edit_tabulator from "./edit_tabulator.vue";
	import treatments from "../services/treatments.js";
	import database from "../views/database.vue";
	import viewFile from "./viewFile.vue";

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	import store from "../store";
	import utils from "../services/utils.js";

	export default {
		name: "treatment",
		components: {
			edit_tabulator,
			FadeLoader: FadeLoader,
			viewFile
		},
		data() {
			return {
				xml: null,
				editor: null,
				editor_text: "",
				extra: true,
				first: false,
				id_treatment: 0,
				inter: 0,
				result: {},
				date_start: "",
				date_end: "",
				status: "",
				details: {},
				project: "",
				project_data: {},
				files: [],
				files_out: [],
				user: null,
				fields: [
					{
						key: "name",
						label: "Fichier",
					},
					{
						key: "download",
						label: "Téléchargement",
					},
				],
				fields_logs: [
					{
						key: "dateheure",
						label: "Date",
					},
					{
						key: "etape_projet_uid",
						label: "Etape",
					},
					{
						key: "log",
						label: "Log",
					},,
					{
						key: "niveau",
						label: "Niveau",
					},
				],
				fields_meters: [
					{
						key: "etape_uid",
						label: "Etape",
					},
					{
						key: "libelle",
						label: "Nom",
					},
					{
						key: "compteur",
						label: "Valeur",
					},
					{
						key: "level",
						label: "Niveau",
					}
				],
				tabulator_data: false,
				tabulator_options: {},
				dowload: true,
				name_file: "",
				list_actions_result: [],
				launch: false,

				details_open: false,
				logs: null,
				meters: null,
				all: false,
				is_create: false,
				id_data_view: null,
				next_treatments: [],
				selection_projects_options: [
					{ value: null, text: "Sélectionner un projet" }
				],
				selection_project: null,
				details_lines: null
			};
		},
        computed: {
			details_json : function()
			{
				return JSON.stringify(this.details, null, 4);
			}
		},
		props: {
			node_workflow: {
				default: () =>  null
			},
			worflow_builder: {
				default: false
			},
			minimal: {},
			list_projects: {
				default: () => []
			},
			workflow: {
				default: false
			}
		},
		methods: {
			stop_treatment()
			{
				this.$set(this.details, "stop", true);
				treatments.stop(this.id_treatment);
			},
			update_file()
			{
				this.$emit("set_data_in", this.workflow);
			},
			add_project_workflow()
			{
				if (this.selection_project)
				{
					console.log(this.$parent)
					this.$emit("add_project_workflow", this.workflow, this.selection_project);
					this.selection_project = null;
				}
			},
			async get_data_out() {
				var files_out = [];

				console.log("this.files_out")
				console.log(this.files_out)

				for (var i = 0; i < this.files_out.length; i++)
				{
					var data = null;
					if (this.files_out[i].id == this.id_data_view)
						data = await this.$refs.view_file.get_data_blob();
					console.log(data)
					if (data)
					{
						files_out.push({
							name: this.files_out[i].name,
							type: "csv",
							data: data
						});
					}
					else
						files_out.push(this.files_out[i]);
				}

				console.log(files_out)

				return files_out;
			},
			send_treatment()
			{
				this.$emit("treatment", this.id_treatment);
			},
			async start_treatment(tags, project, _type) {
				var self = this;

				var name_file_tabulator = this.name_file;
				var tabulator_data_csv =
					await this.$refs.data_tabulator.get_data_blob();

				var type = "import";
				if (_type) type = _type;

				this.launch = true;

				treatments
					.create(
						project,
						null,
						tabulator_data_csv,
						name_file_tabulator,
						tags,
						type
					)
					.then((res) => {
						//this.$router.push({ name: 'treatment', params: { id: res.treatment.uid } })
						this.$refs.myTreatment.start(
							res.treatment.uid,
							true,
							1000
						);
					})
					.catch((err) => {
						console.log("error : " + err);
						this.$notify({
							group: "info",
							title: err.response.data.msg,
							type: "error",
						});
					});
			},
			async getCsv() {
				var self = this;

				this.dowload = false;
				let data = await this.$refs.data_tabulator.get_data_blob();

				// console.log("Data blob ", data);

				return data;
			},
			getTreatment: async function (all) {
				try {
					if (all)
						this.all = all;

					this.result = await treatments.get(this.id_treatment);

					this.project = this.result.project.libelle;

					if (this.workflow)
						this.$emit("set_description_node", this.workflow, "Projet: " + this.project)

					this.project_data = this.result.project;
					if (this.result.project.details)
						this.list_actions_result = this.result.project.details.actions_result;

					this.selection_projects_options = [
						{ value: null, text: "Sélectionner un projet" }
					];
					if (this.list_projects && this.project_data.details && this.project_data.details.details && this.project_data.details.details.next_treatments)
					{							
						var next_treatments = this.project_data.details.details.next_treatments;
						for (var i = 0; i < this.list_projects.length; i++) {
							if (next_treatments && next_treatments.length > 0)
							{
								if (next_treatments.includes(this.list_projects[i]["uid"]))
								{
									this.selection_projects_options.push({
										value: this.list_projects[i]["uid"],
										text: this.list_projects[i]["libelle"],
									});
								}
							}
						}
					}
					this.date_start = this.result.treatment.dateheure_debut;
					this.date_end = this.result.treatment.dateheure_fin;
					this.status = this.result.treatment.resultat;
					this.details = this.result.treatment.details;
					if (this.status == "na") 
						this.status = null;
					this.user = this.result.user;
					var csv_file = null;

					let jwt = store.state.jwt;

					if (this.all)
					{
						this.fields = [
							{
								key: "name",
								label: "Fichier",
								sortable: true
							},
							{
								key: "type",
								label: "Type",
								sortable: true
							},
							{
								key: "download",
								label: "Téléchargement",
							}
						]
					}

				
				if (this.details_view)
				{
					this.logs = await treatments.getLogs(this.id_treatment);
					this.meters = await treatments.getMeters(this.id_treatment);
				}

				if (this.status || this.details_view) 
				{
					if (this.status)
						clearInterval(this.inter);


					var all_files = await treatments.getFiles(
						this.id_treatment
					);

					console.log("get treatment")
					console.log(all_files.length)
					console.log(this.files.length)

					if (all_files.length == this.files.length)
						return;

					if (this.result.treatment.details && this.result.treatment.details.lines && this.status != "ok" && this.status != "ko")
					{
						var details_lines = JSON.stringify(this.result.treatment.details.lines);
						if (details_lines == this.details_lines)
							return;
						this.details_lines = details_lines;
					}
						
					this.files = [];
					this.files_out = [];

					for (var i = 0; i < all_files.length; i++) {
						if (this.all || all_files[i]["type"] == "export") {
							if (!csv_file && all_files[i]["nom_fichier"].endsWith(".csv")) 
							{
								var res = await treatments.getHeadFile(
									all_files[i].uid
								);
								if (
									res.headers["content-length"] < 2000000
								) {
									csv_file = {
										item: {
											name: all_files[i]["nom_fichier"], id: all_files[i]["uid"],
										},
									};
								}
							}
							this.files.push({
								name: all_files[i]["nom_fichier"],
								details: all_files[i]["details"],
								id: all_files[i]["uid"],
								type: all_files[i].type,
								url: all_files[i].url
							});
							if (all_files[i]["type"] == "export")
							{
								this.files_out.push({
									name: all_files[i]["nom_fichier"],
									url: all_files[i].url,
									id: all_files[i]["uid"],
									type: "url"
								});
							}
						}
					}
					if (csv_file)
					{
						this.viewFile(csv_file, csv_file.item.name, null);
					}

					this.$emit("set_data_in", this.workflow);
				}

				} catch (error) {
					console.log(error);
				}
			},
			getFile: async function (data) {
				treatments.getFile(data.item.id, data.item.name);
				this.id_data_view = data.item.id;
			},
			viewFile: async function (data, name, details, file) {
				this.$refs.view_file.viewFile(data, name, details, file);
				this.id_data_view = data.item.id;
			},
			dowloadCSV: function () {
				const tabulatorInstance = this.$refs.tabulator.getInstance();
				tabulatorInstance.download("csv", this.filename);
			},
			dowloadExcel: function () {
				const tabulatorInstance = this.$refs.tabulator.getInstance();
				tabulatorInstance.download(
					"xlsx",
					this.filename.replace(".csv", "") + ".xlsx"
				);
			},
			get_duration: function (date_start, date_end) {
				// calculate time in seconds between two dates
				var diff =
					Math.abs(new Date(date_end) - new Date(date_start)) / 1000;

				return Math.floor(diff) + " secondes";
			},
			start: function (id, extra = true, time = 5000) {
				this.first = true;
				this.extra = extra;

				if (this.inter)
					clearInterval(this.inter);

				this.id_treatment = 0;
				this.inter = 0;
				this.result = {};
				this.date_start = "";
				this.date_end = "";
				this.status = "";
				this.project = "";
				this.files = [];
				this.user = null;
				this.tabulator_options = {};

				var self = this;
				this.id_treatment = id;
				self.getTreatment();
				this.inter = setInterval(function () {
					self.getTreatment();
				}, time);
			},
		},
		created: async function () {
			var self = this;

			this.details_view = true;
			if (store.state.user.rules && !store.state.user.rules.treatment_details) {
				this.details_view = false;
			}

			this.$loadScript(
				"https://oss.sheetjs.com/sheetjs/xlsx.full.min.js"
			);
		},
		beforeDestroy: async function () {
			if (this.inter) {
				clearInterval(this.inter);
			}
		},
	};
</script>

<style scoped lang="scss">
	/* @import '../vuestic-theme/vuestic-sass/resources/_variables.scss'; */

	/* .timebar-1 {
		//background-color: $vue-green;
	} */

	.center_spinner {
		width: 0%;
		margin: 0 auto;
		margin-top: 30px;
	}
</style>
